<span *ngIf="showLoader" class="loading"></span>
